import { css } from "@emotion/react";
import { media } from "styles/breakpoints";
import { theme } from "styles/theme";

export const TransferPointHistoryStyle = {
  timeline: css`
    margin-bottom: 16px;
  `,
  listOrders: css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 16px;
  `,
  table: css`
    display: flex;
    flex-direction: column;
    min-height: 50px;
    align-items: center;
  `,
  tableContent: css`
    display: flex;
    width: 100%;
    justify-content: space-between;
    text-align: center;
    min-height: 52px;
    color: ${theme.colors.lightText};

    &:nth-of-type(odd) {
      background-color: ${theme.colors.black100};
    }

    &:nth-of-type(even) {
      background-color: #1d1d1d;
    }

    span {
      flex: 1 1 0%;
      font-size: 13px;
      text-align: center;
      word-break: break-word;
      overflow: hidden;
      justify-content: center;
      align-items: center;
      display: flex;
      padding: 12px 8px;
    }
  `,
  cardList: css`
    display: flex;
    flex-direction: column;
    gap: 12px;
  `,
  cardItem: css`
    padding: 14px 16px;
    border-radius: 12px;
    border: 1px solid ${theme.palette.border.default};
    background: rgba(255, 255, 255, 0.03);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  `,
  cardRow: css`
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 6px 0;
    border-bottom: 1px solid ${theme.palette.border.subtle};

    &:last-of-type {
      border-bottom: none;
      padding-bottom: 0;
    }

    &:first-of-type {
      padding-top: 0;
    }
  `,
  cardLabel: css`
    color: ${theme.palette.text.muted};
    font-size: ${theme.typography.caption.fontSize};
    line-height: ${theme.typography.caption.lineHeight};
  `,
  cardValue: css`
    color: ${theme.palette.text.primary};
    font-size: ${theme.typography.body.fontSize};
    font-weight: ${theme.typography.body.fontWeight};
    line-height: ${theme.typography.body.lineHeight};
    text-align: right;
    word-break: break-word;
  `,
  amountValue: css`
    color: ${theme.colors.darkGreen};
  `,
  full: css`
    width: 100%;
    margin-top: 24px;
  `,
  loading: css`
    height: 20px;
    border-radius: 10px;
    background-color: #1a1509;
  `,
  mobileLoading: css`
    height: 112px;
    border-radius: 12px;
    background: #1a1509;
  `,
  titleTable: css`
    margin-top: 16px;

    ${media.md} {
      display: none;
    }
  `,
};
